import React, { useState, useEffect } from "react";
import ScreenHeading from "../../utilities/ScreenHeading/ScreenHeading";
import ScrollService from "../../utilities/ScrollService";
import Animations from "../../utilities/Animations";
import "./Resume.css";
import resume from '../../assets/Resume/Merajul_Resume.pdf';

const Resume = (props) => {
  /* STATES */
  const [selectedBulletIndex, setSelectedBulletIndex] = useState(0);
  const [carousalOffsetStyle, setCarousalOffsetStyle] = useState({});

  let fadeInScreenHandler = (screen) => {
    if (screen.fadeInScreen !== props.id) return;

    Animations.animations.fadeInScreen(props.id);
  };
  const fadeInSubscription =
    ScrollService.currentScreenFadeIn.subscribe(fadeInScreenHandler);

  /* REUSABLE MINOR COMPONENTS */
  const ResumeHeading = (props) => {
    return (
      <div className="resume-heading">
        <div className="resume-main-heading">
          <div className="heading-bullet"></div>
          <span>{props.heading ? props.heading : ""}</span>
          {props.fromDate && props.toDate ? (
            <div className="heading-date">
              {props.fromDate + "-" + props.toDate}
            </div>
          ) : (
            <div></div>
          )}
        </div>
        <div className="resume-sub-heading">
          <span>{props.subHeading ? props.subHeading : ""}</span>
        </div>
        <div className="resume-heading-description">
          <span>{props.description ? props.description : ""}</span>
        </div>
      </div>
    );
  };

  /* STATIC RESUME DATA FOR THE LABELS*/
  const resumeBullets = [
    { label: "Education", logoSrc: "education.svg" },
    { label: "Professional Course", logoSrc: "work-history.svg" },
    { label: "Programming Skills", logoSrc: "programming-skills.svg" },
    { label: "Projects", logoSrc: "projects.svg" },
    { label: "Interests", logoSrc: "interests.svg" },
  ];

  //here we have
  const programmingSkillsDetails = [
    { skill: "JavaScript", ratingPercentage: 70 },
    { skill: "React JS", ratingPercentage: 75 },
    { skill: "React Native", ratingPercentage: 60 },
    { skill: "Express JS", ratingPercentage: 70 },
    { skill: "Node JS", ratingPercentage: 75 },
    { skill: "MongoDb", ratingPercentage: 70 },
    { skill: "HTML", ratingPercentage: 85 },
    { skill: "CSS", ratingPercentage: 85 },
    { skill: "BootStrap", ratingPercentage: 85 },
    { skill: "Tailwind CSS", ratingPercentage: 85 },
    { skill: "Core Java", ratingPercentage: 55 },
    { skill: "Python", ratingPercentage: 75 },
  ];

  const projectsDetails = [
    {
      title: "Raj Supreme Tourist Service",
      duration: { fromDate: "2022", toDate: "present" },
      description:
        ">> See Below Project Details Section for Details of this Project. <<",
      subHeading: "Technologies Used: ReactJS, ExpressJS, Node js, MongoDB,Tailwind CSS , DaisyUI, REST API, Firebase.",
    },
    {
      title: "Meraj-Doctors Portal ",
      duration: { fromDate: "2022", toDate: "present" },
      description:
        ">> See Below Project Details Section for Details of this Project. <<",
      subHeading:
        "Technologies Used: ReactJS, ExpressJS, NodesJS, RegEx,MongoDB, Tailwind CSS, DaisyUI, REST API, Axios, Stripe JS,JWT token, React Query , Firebase",
    },
    {
      title: "Ema John Shopping-Ecommerce Website ",
      duration: { fromDate: "2022", toDate: "present" },
      description:
        "See Below Project Details Section for Details of this Project. ",
      subHeading:
        "Technologies Used: ReactJS, ExpressJS, NodeJS, MongoDB, CSS-3, API, Firebase.",
    },
  ];

  const resumeDetails = [
    <div className="resume-screen-container" key="education">
      <ResumeHeading
        heading={"CITY UNIVERSITY, DHAKA, BANGLADESH"}
        subHeading={"Bachelor Of Computer Science & Engineering  || CGPA: 3.43 (0ut Of 4)"}
        fromDate={"2018"}
        toDate={"2022"}
      />

      <ResumeHeading
        heading={"PIRGONJ COLLEGE"}
        subHeading={"H.S.C || GPA: 5 (Out Of 5)"}
        fromDate={"2016"}
        toDate={"2017"}
      />
      <ResumeHeading
        heading={"PIRGONJ GOVT.MENT HIGH SCHOOL"}
        subHeading={"S.S.C || GPA: 5 (Out Of 5)"}
        fromDate={"2014"}
        toDate={"2014"}
      />
    </div>,

    /* WORK EXPERIENCE */
    <div className="resume-screen-container" key="work-experience">
      <div className="experience-container">
        <ResumeHeading
          heading={"Organization Name: Programming Hero"}
          subHeading={"Course Name : Complete  Web Development Course (MERN Stack ) With Jhankar  Mahbub"}
          fromDate={"2022"}
          toDate={"present"}
        />
        <div className="experience-description">
          <span className="resume-description-text">
            In Programming Hero i have learned and gather deep knowledge about full stack web development.
            This Course really helped me lot to gather my experience.Through out the whole course i learned HTML-5,CSS-3,BootStrap-5, TailwindCSS,DaisyUI,JavaScript,
           DOM,ReactJS, NodeJS,ExpressJS ,MongoDB,CRUD Operation,Redux,Material UI.
          </span>
        </div>

        <ResumeHeading
          heading={"Organization Name: NIET"}
          subHeading={"Course Name : Complete  Web Design Course"}
          fromDate={"2018"}
          toDate={"2019"}
        />
        <div className="experience-description">
          <span className="resume-description-text">
            In this institution i learned about web design or Fron end part.For instant HTML,CSS,Bootstrap,JavaScript.
          </span>
          <br />
        </div>
      </div>
    </div>,

    /* PROGRAMMING SKILLS */
    <div
      className="resume-screen-container programming-skills-container"
      key="programming-skills"
    >
      {programmingSkillsDetails.map((skill, index) => (
        <div className="skill-parent" key={index}>
          <div className="heading-bullet"></div>
          <span>{skill.skill}</span>
          <div className="skill-percentage">
            <div
              style={{ width: skill.ratingPercentage + "%" }}
              className="active-percentage-bar"
            ></div>
          </div>
        </div>
      ))}
    </div>,

    /* PROJECTS */
    <div className="resume-screen-container" key="projects">
      {projectsDetails.map((projectsDetails, index) => (
        <ResumeHeading
          key={index}
          heading={projectsDetails.title}
          subHeading={projectsDetails.subHeading}
          description={projectsDetails.description}
          fromDate={projectsDetails.duration.fromDate}
          toDate={projectsDetails.duration.toDate}
        />
      ))}
    </div>,

    /* Interests */
    <div className="resume-screen-container" key="interests">
      <ResumeHeading
        heading="Artificial Intelligence"
        description="Apart from being a Web developer and a code writer, i also love to learn about Artificial Intelligence."
      />
      <ResumeHeading
        heading="Learning Python and Machine Learning"
        description=" Python is a programming language that distinguishes itself from other programming languages by its flexibility, simplicity, and reliable tools.So in that case i also love gather my knowledge in ML."
      />
      <ResumeHeading
        heading="Cyber Security"
        description="Cyber Security is now becoming global concern across the world.To improve in this field i also love to learn Cyber Security."
      />
    </div>,
  ];

  const handleCarousal = (index) => {
    let offsetHeight = 360;

    let newCarousalOffset = {
      style: { transform: "translateY(" + index * offsetHeight * -1 + "px)" },
    };

    setCarousalOffsetStyle(newCarousalOffset);
    setSelectedBulletIndex(index);
  };

  const getBullets = () => {
    return resumeBullets.map((bullet, index) => (
      <div
        onClick={() => handleCarousal(index)}
        className={
          index === selectedBulletIndex ? "bullet selected-bullet" : "bullet"
        }
        key={index}
      >
        <img
          className="bullet-logo"
          src={require(`../../assets/Resume/${bullet.logoSrc}`)}
          alt="B"
        />
        <span className="bullet-label" style={{color:'lightcoral',fontWeight:'bold'}}>{bullet.label}</span>
      </div>
    ));
  };

  const getResumeScreens = () => {
    return (
      <div
        style={carousalOffsetStyle.style}
        className="resume-details-carousal"
      >
        {resumeDetails.map((ResumeDetail) => ResumeDetail)}
      </div>
    );
  };

  useEffect(() => {
    return () => {
      /* UNSUBSCRIBE THE SUBSCRIPTIONS */
      fadeInSubscription.unsubscribe();
    };
  }, [fadeInSubscription]);

  return (
    <div
      className="resume-container screen-container fade-in"
      id={props.id || ""}
    >
      <div className="resume-content">
        <ScreenHeading title={"Resume"} subHeading={"My formal Bio Details"} />
        <div className="resume-card">
          <div className="resume-bullets">
            <div className="bullet-container">
              <div className="bullet-icons"></div>
              <div className="bullets">{getBullets()}</div>
            </div>
          </div>

          <div className="resume-bullet-details">{getResumeScreens()}</div>
        </div>
      </div>
      <a href={resume} className="get_resume" download="Merajul_Resume.pdf">
              <button className="btn highlighted-btn mt-4">Get This Resume</button>
            </a>
    </div>
  );
};

export default Resume;
